// extracted by mini-css-extract-plugin
export default {"large":"QX4iD","numericRating":"I21qs","overallRating":"X3LJZ"};